import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import axios from 'axios';

export interface VendorIdentity {
  id: string;
  name: string;
}

interface VendorLoginResponse {
  accessToken: string;
  refreshToken: string;
  vendor: VendorIdentity;
}

interface VendorAuthState {
  accessToken: string | null;
  refreshToken: string | null;
  vendor: VendorIdentity | null;
  login: (idCardNumber: string, password: string) => Promise<void>;
  logout: () => void;
  setVendor: (vendor: VendorIdentity) => void;
}

// Bare axios for auth calls so they don't hit the authed vendor interceptor.
const bare = axios.create({ baseURL: '/api/vendor' });

export const useVendorAuthStore = create<VendorAuthState>()(
  persist(
    (set, get) => ({
      accessToken: null,
      refreshToken: null,
      vendor: null,
      login: async (idCardNumber, password) => {
        const r = await bare.post<VendorLoginResponse>('/auth/login', { idCardNumber, password });
        set({
          accessToken: r.data.accessToken,
          refreshToken: r.data.refreshToken,
          vendor: r.data.vendor,
        });
      },
      logout: () => {
        const rt = get().refreshToken;
        const at = get().accessToken;
        if (rt || at) {
          void bare
            .post('/auth/logout', {}, at ? { headers: { Authorization: `Bearer ${at}` } } : undefined)
            .catch(() => undefined);
        }
        set({ accessToken: null, refreshToken: null, vendor: null });
      },
      setVendor: (vendor) => set({ vendor }),
    }),
    { name: 'wappro.vendorAuth' },
  ),
);
